var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7083 6.66683C12.7083 8.1626 11.4957 9.37516 9.99998 9.37516C8.50421 9.37516 7.29164 8.1626 7.29164 6.66683C7.29164 5.17106 8.50421 3.9585 9.99998 3.9585C11.4957 3.9585 12.7083 5.17106 12.7083 6.66683Z",
    stroke: "#8A8AA3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70623 16.0418H14.2937C15.2453 16.0418 15.9783 15.2236 15.5339 14.3821C14.8803 13.1444 13.39 11.6668 9.99998 11.6668C6.60999 11.6668 5.1197 13.1444 4.46601 14.3821C4.02162 15.2236 4.75463 16.0418 5.70623 16.0418Z",
    stroke: "#8A8AA3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic_user.0119e914b74977b2ed9e9d24f64133de.svg";
export { ForwardRef as ReactComponent };